<template>
    <div class="publicMain1 head">
        <div class="title">工单量统计</div>
        <div class="context">
            <div class="context-left">
                <div class="context-left-item context-left-item1">
                    <div class="context-left-item-context">
                        <div class="context-left-item-context-left">
                            <div class="context-left-item-context-left-piece">2342件</div>
                            <div class="context-left-item-context-left-piece1">工单总数</div>
                        </div>
                        <div class="context-left-item-context-right">
                            <div class="context-left-item-context-left-piece">2342件</div>
                            <div class="context-left-item-context-left-piece1">本月工单</div>
                        </div>
                    </div>
                </div>
                <div class="context-left-item">
                        <div class="charts-title">工单统计类型</div>
                        <div ref="chart" id="chart" style="width:100%;height:calc(100% - 50px)"></div>
                </div>
                <div class="context-left-item">
                    <div class="charts-title">服务人员统计</div>
                    <div id="myChart" style="width:100%;height:calc(100% - 50px)"></div>
                </div>
            </div>
            <div class="context-right">
                <div class="context-right-item">
                    <div ref="chart" id="myChart1" style="width:100%;height:calc(100% - 50px)"></div>
                </div>
                <div class="context-right-item">
                    <div class="charts-title">工单状态统计</div>
                    <div ref="chart" id="myChart2" style="width:100%;height:calc(100% - 50px)"></div>
                </div>
                <div class="context-right-item">
                    <div class="charts-title">工单时长统计</div>
                    <div ref="chart" id="myChart3" style="width:100%;height:calc(100% - 50px)"></div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                msg: "Welcome to Your Vue.js App"
            };
        },
        methods: {

            getEchartData() {
                // const chart = this.$refs.chart;
                const myChart = this.$echarts.init(document.getElementById("chart"));
                const option = {
                    title: {
                        text: "",
                        subtext: "",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"],
                    },
                    series: [
                        {
                            name: "访问来源",
                            type: "pie",
                            radius: "55%",
                            center: ["50%", "60%"],
                            data: [
                                {
                                    value: 335,
                                    name: "家政",
                                    itemStyle: {color: "rgb(58,161,255)"},
                                },
                                {
                                    value: 310,
                                    name: "代购代办",
                                    itemStyle: {color: "rgb(151,95,229)"},
                                },
                                {
                                    value: 234,
                                    name: "医疗",
                                    itemStyle: {color: "rgb(240,72,100)"},
                                },
                                {
                                    value: 135,
                                    name: "回收",
                                    itemStyle: {color: "rgb(251,212,55)"},
                                },
                                {
                                    value: 1548,
                                    name: "其他",
                                    itemStyle: {color: "rgb(78,203,115)"},
                                },
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                        },
                    ],
                };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });

                this.$on("hook:destroyed", () => {
                    window.removeEventListener("resize", function () {
                        myChart.resize();
                    });
                });
            },
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("myChart"));
                // 绘制图表
                myChart.setOption({
                    title: {text: ""},
                    tooltip: {},
                    xAxis: {
                        data: ["第一网格", "第二网格", "第三网格", "第四网格", "第五网格", "第六网格", "第七网格"],
                        textStyle: {
                            color: "akyblue",
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            textStyle: {
                                color: "#999",
                            },
                        },
                    },
                    series: [
                        {
                            name: "销量",
                            type: "bar",
                            data: [5, 20, 36, 10, 10, 20, 20],
                            itemStyle: {
                                normal: {
                                    color: "#4ad2ff",
                                },
                            },
                        },
                    ],
                });
            },
            drawLine1() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("myChart1"));
                // 绘制图表
                myChart.setOption({
                    title: {text: ""},
                    tooltip: {},
                    xAxis: {
                        data: ["第一网格", "第二网格", "第三网格", "第四网格", "第五网格", "第六网格", "第七网格"],
                        textStyle: {
                            color: "akyblue",
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            textStyle: {
                                color: "#999",
                            },
                        },
                    },
                    series: [
                        {
                            name: "销量",
                            type: "bar",
                            data: [5, 20, 36, 10, 10, 20, 20],
                            itemStyle: {
                                normal: {
                                    color: "#4ad2ff",
                                },
                            },
                        },
                    ],
                });
            },
            drawLine2() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("myChart2"));
                // 绘制图表
                myChart.setOption({
                    title: {text: ""},
                    tooltip: {},
                    xAxis: {
                        data: ["第一网格", "第二网格", "第三网格", "第四网格", "第五网格", "第六网格", "第七网格"],
                        textStyle: {
                            color: "akyblue",
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            textStyle: {
                                color: "#999",
                            },
                        },
                    },
                    series: [
                        {
                            name: "销量",
                            type: "bar",
                            data: [5, 20, 36, 10, 10, 20, 20],
                            itemStyle: {
                                normal: {
                                    color: "#4ad2ff",
                                },
                            },
                        },
                    ],
                });
            },
            drawLine3() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("myChart3"));
                // 绘制图表
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: ["第一网格", "第二网格", "第三网格", "第四网格", "第五网格", "第六网格", "第七网格"],
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [500, 1000, 2000, 3000, 4000, 5000],
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: "#4ad2ff",
                            },
                        },
                    }]
                });
            },
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(()=>{
                    this.getEchartData()
                    this.drawLine()
                    this.drawLine1()
                    this.drawLine2()
                    this.drawLine3()
                },500)

            });
        }
    };
</script>

<style lang="less" scoped>

    .head {
        width: 100%;
        height: calc(100vh - 80px);
        overflow: auto;
    }

    .title {
        font-weight: 700;
        border-bottom: 1px solid rgb(200, 200, 200);
        margin-top: 50px;
        float: right;
        width: 96%;
        padding-bottom: 10px;
    }

    .context {
        width: 100%;
        height: calc(100vh - 180px);
        margin-top: 80px;
        display: flex;
    }
    .context-left {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .context-left-item {
        height: 33%;
        width: 100%;
    }
    .context-right {
        width: 50%;
        height: 100%;
    }
    .context-left-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .context-left-item-context {
        width: 450px;
        height: 135px;
        display: flex;
        justify-content: space-between;
    }
    .context-left-item-context-left {
        width: 200px;
        height: 100%;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgb(58,161,255);
    }
    .context-left-item-context-right {
        width: 200px;
        height: 100%;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgb(220,181,25);
    }
    .context-left-item-context-left-piece {
        font-size: 28px;
        color: #FFF;

    }
    .context-left-item-context-left-piece1 {
        margin-top: 20px;
        color: #FFF;

    }
    .charts-title {
        font-weight: 700;
        border-bottom: 1px solid rgb(200, 200, 200);
        margin-left: 52px;
        padding-bottom: 20px;
    }
    #myChart {
        width: 100%;
        height: 350px;
    }
    .context-right-item {
        width: 100%;
        height: 33.33%;
    }

</style>